/**
 * ランタイム設定 (`/config.json`) のロード処理。
 *
 * - CDK が S3 に配置した `/config.json` を fetch する想定。
 * - dev サーバ起動時は `public/config.json` が同じパスで提供される。
 */

export interface AppConfig {
  /** ControlPanel API のベース URL (末尾スラッシュあり) */
  apiUrl: string;
  /** AWS リージョン (例: ap-northeast-1) */
  region: string;
  /** Cognito User Pool ID */
  userPoolId: string;
  /** Cognito User Pool Client ID (App Client) */
  userPoolClientId: string;
}

const REQUIRED_KEYS: (keyof AppConfig)[] = ['apiUrl', 'region', 'userPoolId', 'userPoolClientId'];

/** `/config.json` を fetch して AppConfig として返す。 */
export async function loadAppConfig(): Promise<AppConfig> {
  const res = await fetch('/config.json', { cache: 'no-store' });
  if (!res.ok) {
    throw new Error(`Failed to fetch /config.json: HTTP ${res.status}`);
  }
  const json = (await res.json()) as Partial<AppConfig>;
  for (const key of REQUIRED_KEYS) {
    if (!json[key]) {
      throw new Error(`/config.json is missing required key: ${key}`);
    }
  }
  return json as AppConfig;
}
